export default ({ env }, inject) => {
  const { USETIFUL_TOKEN } = env

  function insertUsetifulScript() {
    if (!USETIFUL_TOKEN) return

    const head = document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://www.usetiful.com/dist/usetiful.js'
    script.id = 'usetifulScript'
    script.dataset.token = USETIFUL_TOKEN
    head.appendChild(script)
  }

  function removeUsetifulScript() {
    const existingScript = document.getElementById('usetifulScript')
    if (existingScript) {
      existingScript.remove()
    }
  }

  function usetifulTags(userId, segment, email) {
    if (!USETIFUL_TOKEN) return

    if (window.usetifulTags) {
      removeUsetifulScript()
    }

    window.usetifulTags = { userId, segment, email }
    insertUsetifulScript()
  }

  function refreshTags() {
    if (!USETIFUL_TOKEN || !window.usetifulTags) {
      return
    }

    removeUsetifulScript()
    insertUsetifulScript()
  }

  inject('usetiful', {
    usetifulTags,
    refreshTags
  })
}
